<template>
  <div>
    <Breadcrumbs main="Розыгрыши" title="Создание розыгрыша"></Breadcrumbs>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5>Создание розыгрыша</h5>
            </div>
            <div class="card-body">
              <b-card>
                <GiveawayForm
                    ref="giveawayForm"
                    v-model="giveawayData"
                    :is-saving="isSaving"
                    submit-text="Создать розыгрыш"
                    @submit="submitGiveaway"
                />
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import GiveawayForm from "@/pages/Giveaways/GiveawayForm.vue";
import {GiveawayAdapterMixin} from "@/mixins/Giveaways/GiveawayAdapterMixin";

export default {
  name: 'CreateGiveaway',
  mixins: [GiveawayAdapterMixin],
  components: {GiveawayForm},
  data() {
    return {
      isSaving: false,
      giveawayData: {
        name: '',
        game_id: null,
        starts_at: null,
        ends_at: null,
        coupons_count: null,
      },
    };
  },
  methods: {
    ...mapActions('moduleGiveaways', ['createGiveaway']),
    async submitGiveaway() {
      this.isSaving = true;
      try {
        await this.createGiveaway({
          name: this.giveawayData.name,
          game_id: this.giveawayData.game_id,
          starts_at: this.toIsoWithOffset(this.giveawayData.starts_at),
          ends_at: this.toIsoWithOffset(this.giveawayData.ends_at),
          coupons_count: this.giveawayData.coupons_count,
        });
        this.$router.push({name: 'list_giveaways'});
      } catch (error) {
        console.error('Error creating giveaway:', error);
        this.$refs.giveawayForm?.setServerErrors(error?.response?.data?.errors);
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>
